import { render } from "./taskStatus.vue?vue&type=template&id=1ffc7571&scoped=true"
import script from "./taskStatus.vue?vue&type=script&lang=js"
export * from "./taskStatus.vue?vue&type=script&lang=js"

import "./taskStatus.vue?vue&type=style&index=0&id=1ffc7571&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffc7571"]])

export default __exports__